module.exports = __webpack_public_path__ + "media/images/doctor_congrats_1-f72caee733dff958ad2f670506b54a92.jpg";